import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
var ModalContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalContainer",
  componentId: "sc-19nh2hf-0"
})(_templateObject(), function (_ref) {
  var zIndex = _ref.zIndex;
  return zIndex;
});
export default ModalContainer;